import { DishSetAreaString } from './../../models/dish-set-area-string.entity';
import { DishSetArea } from './../../models/dish-set-area.entity';
import http, { HttpSuccessOrErrorType } from '../http';
import { DishDynamicInfo, Condition, DishStaticInfo, ResultSetHeader, DishString, DishSetAreaDetail } from '../../models';
export default {
    /**
     * 查询 所有 dish 资源
     * @param string_id 参数
     */
    async get_restaurant_string_id_dish_condition(params: Condition & Omit<DishDynamicInfo, 'status' | 'item_id'> & { string_id: string, status?: Array<string>, item_id?: number[] }): Promise<HttpSuccessOrErrorType<DishStaticInfo[]>> {
        const { string_id, status, item_id, ...rest } = params;
        // $ 需要手动拼接 [0,1,2] get无法传递数组
        let statusString = '';
        status?.forEach(i => {
            statusString += (statusString ? '&' : '?') + `status=${i}`;
        })
        item_id?.forEach(i => {
            statusString += (statusString ? '&' : '?') + `item_id=${i}`;
        })

        return await http.get(`/restaurant/${string_id}/dish/condition${statusString}`, {
            params: {
                ...rest,

            }
        })
    },

    /**
     * 查询 单个dish
     * @param string_id 参数
     */
    async get_restaurant_string_id_dish_item_id(params: { string_id: string, item_id: string }): Promise<HttpSuccessOrErrorType<DishStaticInfo>> {
        const { string_id, item_id } = params;
        return await http.get(`/restaurant/${string_id}/dish/${item_id}`, {
        })
    },

    /**
     * 查询 菜品静态信息
     * @param string_id 参数
     */
    async get_dish_static_condition(params: { string_id: string } & DishStaticInfo & Condition): Promise<HttpSuccessOrErrorType<DishStaticInfo>> {
        const { string_id, ...rest } = params;
        return await http.get(`/restaurant/${string_id}/dish/static/condition`, {
            params: {
                ...rest
            }
        })
    },

    /**
     * 获取套餐组列表
     * @param params 查询条件参数
     */
    async get_dish_set_areas(params: { string_id: string } & DishSetAreaDetail & Condition): Promise<HttpSuccessOrErrorType<DishSetArea[]>> {
        const { string_id, ...rest } = params;
        return await http.get(`/restaurant/${string_id}/dish/set/areas/condition`, {
            params: {
                ...rest
            }
        })
    },

    /**
     * 创建套餐组
     * @param params 参数
     */
    async create_dish_set_area(params: DishSetArea & { string_id: string }): Promise<HttpSuccessOrErrorType<ResultSetHeader>> {
        const { string_id, ...rest } = params;
        return await http.post(`/restaurant/${string_id}/dish/set/area`, {
            ...rest
        })
    },

    /**
     * 创建菜品，包括DishDynamicInfo DishStaticInfo资源。
     * @param params 参数
     */
    async post_restaurant_string_id_dish(params: DishStaticInfo & { string_id: string }): Promise<HttpSuccessOrErrorType<ResultSetHeader>> {
        const { string_id, ...rest } = params
        return await http.post(`/restaurant/${string_id}/dish`, {
            ...rest
        })
    },

    /**
     * 编辑套餐组
     * @param params 参数
     */
    async patch_dish_set_area(params: DishSetArea & { string_id: string }): Promise<HttpSuccessOrErrorType<ResultSetHeader>> {
        const { string_id, id, ...rest } = params;
        return await http.patch(`/restaurant/${string_id}/dish/set/area/${id}`, {
            ...rest
        })
    },

    /**
     * 创建单个DishStaticInfo资源
     * @param params 参数
     */
    async post_restaurant_string_id_dish_static(params: DishStaticInfo & { string_id: string }): Promise<HttpSuccessOrErrorType<ResultSetHeader>> {
        const { string_id, ...rest } = params
        return await http.post(`/restaurant/${string_id}/dish/static`, {
            ...rest
        })
    },

    /**
     * 套餐组动态国际化
     * @param params 参数
     */
    async dish_set_area_strings(params: { string_id: string, request: DishSetAreaString[] }): Promise<HttpSuccessOrErrorType<ResultSetHeader[]>> {
        const { string_id, request } = params;
        return await http.post(`/restaurant/${string_id}/dish_set_area/dish_set_area_strings`, request)
    },

    /**
     * 批量删除套餐组
     * @param params 参数
     */
    async delete_dish_set_areas(params: { string_id: string, ids: Array<number> }): Promise<HttpSuccessOrErrorType<ResultSetHeader>> {
        const { string_id, ids } = params;
        return await http.delete(`/restaurant/${string_id}/dish/set/areas`, {
            data: {
                ids
            }
        })
    },

    /**
     * 创建套餐组菜品动态信息
     * @param params 参数
     */
    async create_dish_set_area_detail(params: DishSetAreaDetail & { string_id: string }): Promise<HttpSuccessOrErrorType<ResultSetHeader>> {
        const { string_id, area_id, ...rest } = params;
        return await http.post(`/restaurant/${string_id}/dish/set/area/${area_id}/detail`, {
            ...rest
        })
    },

    /**
     * 修改套餐组菜品动态信息
     * @param params 参数
     */
    async patch_dish_set_area_detail(params: DishSetAreaDetail & { string_id: string }): Promise<HttpSuccessOrErrorType<ResultSetHeader>> {
        const { string_id, area_id, id, ...rest } = params;
        return await http.patch(`/restaurant/${string_id}/dish/set/area/${area_id}/detail/${id}`, {
            ...rest
        })
    },

    /**
     * 创建或者修改多个dish_string资源。
     * @param params 参数
     */
    async post_restaurant_string_id_dish_dish_strings(params: { string_id: string, ruleSetInfo: Array<DishString> }): Promise<HttpSuccessOrErrorType<ResultSetHeader>> {
        const { string_id, ruleSetInfo } = params
        return await http.post(`/restaurant/${string_id}/dish/dish_strings`, ruleSetInfo)
    },

    /**
     * 修改单个Dish资源,可以同时修改DishDynamicInfo和DishStaticInfo。
     * @param string_id 餐厅string_id
     * @param params 参数
     */
    async patch_restaurant_string_id_dish_item_id(params: DishDynamicInfo & { string_id: string }): Promise<HttpSuccessOrErrorType<ResultSetHeader>> {
        const { string_id, item_id, ...rest } = params;
        return await http.patch(`/restaurant/${string_id}/dish/${item_id}`, {
            ...rest
        })
    },


    /**
     * 删除多个DishDynamicInfo资源。
     * @param string_id 餐厅id
     * @param ids 需要删除的套餐组id数组
     */
    async delete_restaurant_string_id_dishes(params: { string_id: string, ids: Array<number> }): Promise<HttpSuccessOrErrorType<ResultSetHeader>> {
        const { string_id, ids } = params;
        return await http.delete(`/restaurant/${string_id}/dishes`, {
            data: {
                ids
            }
        })
    },

    /**
     * 修改单个DishStaticInfo资源
     */
    async patch_restaurant_string_id_dish_static_id(params: DishStaticInfo & { string_id: string }): Promise<HttpSuccessOrErrorType<ResultSetHeader>> {
        const { string_id, id, ...rest } = params;
        return await http.patch(`/restaurant/${string_id}/dish/static/${id}`, {
            ...rest
        })
    },

    /**
     * 批量删除DishStaticInfo资源,彻底删除：无论关联了什么，都一起删除掉。
     * @param string_id 餐厅id
     * @param ids 需要删除的套餐组id数组
     */
    async delete_restaurant_string_id_dish_statics_all(params: { string_id: string, ids: Array<number> }): Promise<HttpSuccessOrErrorType<ResultSetHeader>> {
        const { string_id, ids } = params;
        return await http.delete(`/restaurant/${string_id}/dish/statics/all`, {
            data: {
                ids
            }
        })
    },

    /**
     * 批量删除DishSetAreaDetail资源。
     * @param params 参数
     */
    async delete_set_area_details(params: { string_id: string, ids: Array<number> }): Promise<HttpSuccessOrErrorType<ResultSetHeader>> {
        const { string_id, ids } = params;
        return await http.delete(`/restaurant/${string_id}/dish/set/area/details`, {
            data: {
                ids
            }
        })
    },
    /**
     * 批量移动dishDynamic资源。
     */
    async patch_restaurant_string_id_dish_shift(params: { string_id: string, ids: number[], slu_id: number }): Promise<HttpSuccessOrErrorType<ResultSetHeader>> {
        const { string_id, ...rest } = params;
        return await http.patch(`/restaurant/${string_id}/dish/shift`, {
            ...rest
        })
    },

    /**
     * 批量复制dishDynamic资源。
     * @param params 参数
     */
    async post_restaurant_string_id_dish_copy(params: { string_id: string, ids: number[], slu_id: number }): Promise<HttpSuccessOrErrorType<ResultSetHeader>> {
        const { string_id, ...rest } = params
        return await http.post(`/restaurant/${string_id}/dish/copy `, {
            ...rest
        })
    },

    /**
     * 修改指定套餐所拥有的区域DishSetAreaRelationship资源,以传入数据为最终数据，传入套餐的原有套餐区域会被覆盖
     */
    async patch_restaurant_string_id_dish_set_area_relationships(params: { string_id: string, dish_dynamic_info_id: number, dish_set_area_ids: number[] }): Promise<HttpSuccessOrErrorType<ResultSetHeader>> {
        const { string_id, ...rest } = params;
        return await http.patch(`/restaurant/${string_id}/dish/set_area/relationships`, {
            ...rest
        })
    },

    /**
     * 批量修改静态菜品
     * @param params 参数
     */
    async patch_dish_statics(params: { string_id: string, dishes: DishStaticInfo[] }): Promise<HttpSuccessOrErrorType<ResultSetHeader>> {
        const { string_id, dishes } = params;
        return await http.patch(`/restaurant/${string_id}/dish/statics`, dishes)
    },


}